import { Spinner } from '@personachat/ui';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSession } from './AuthProvider';

/** Laisse passer un admin connecté ; sinon renvoie à la connexion, en gardant la page demandée. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useSession();
  const location = useLocation();

  if (status === 'booting') {
    return (
      <div className="boot-screen">
        <Spinner label="Ouverture de la session" />
      </div>
    );
  }
  // Mot de passe accepté mais code (ou activation) attendu : l'écran de connexion prend la suite.
  if (status === 'anonymous' || status === 'second-factor' || status === 'enrollment') {
    return <Navigate to="/connexion" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  return <>{children}</>;
}
